import React from "react";

export const formGroupBBNLeasing = {
    handOverNumber: { value: "" },
    periodHandOver: { value: "" },
    leasingId: { value: "", mandatory: true },
    receiptName: { value: "", mandatory: true },
    contactNumber: { value: "", mandatory: true },
    jabatan: { value: "", mandatory: true },
    idPegawai: { value: "", mandatory: true },
    detail: { value: [] },
}

export const initialData = {
    search: {
        startPeriod: null,
        endPeriod: null,
        stnkName: null,
    },
    filter: {
        handOverNumber: null,
        startPeriod: null,
        endPeriod: null,
        leasingName: null,
        receiptName: null,
        contactNumber: null,
        stnkName: null,
        buyer: null,
        frameNumber: null,
        engineNumber: null,
    }
}

export const tableColumns = {
    firstPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const { page, rowsPerPage } = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "period",
            label: "Tanggal Penyerahan",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "handOverNumber",
            label: "Nomor Penyerahan",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "leasingName",
            label: "Nama LEASING",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "receiptName",
            label: "Nama Penerima",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "noHP",
            label: "Nomor HP",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "totalItem",
            label: "Total Item",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
    ],
    secondPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const { page, rowsPerPage } = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "factureDate",
            label: "Tanggal Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "facture",
            label: "Nomor Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "leasingName",
            label: "Nama LEASING",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "bookNumber",
            label: "No. Buku",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "variant",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{val?.kodeVariant}</p>,
                sort: false,
            },
        },
        {
            name: "warna",
            label: "Kode Warna",
            options: {
                customBodyRender: (val) => <p>{val?.kodeWarna}</p>,
                sort: false,
            },
        },
        {
            name: "warna",
            label: "Nama Warna",
            options: {
                customBodyRender: (val) => <p>{val?.namaWarnaKomersil}</p>,
                sort: false,
            },
        },
        {
            name: "stnkName",
            label: "Nama STNK",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "buyer",
            label: "Nama Pembeli",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "frameNumber",
            label: "Nomor Rangka",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "engineNumber",
            label: "Nomor Mesin",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
    ],
    thirdPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const { page, rowsPerPage } = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "factureDate",
            label: "Tanggal Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "facture",
            label: "Nomor Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "bookNumber",
            label: "No. Buku",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "variant",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{val?.kodeVariant}</p>,
                sort: false,
            },
        },
        {
            name: "variant",
            label: "Nama Varian",
            options: {
                customBodyRender: (val) => <p>{val?.namaVariant}</p>,
                sort: false,
            },
        },
        {
            name: "warna",
            label: "Kode Warna",
            options: {
                customBodyRender: (val) => <p>{val?.kodeWarna}</p>,
                sort: false,
            },
        },
        {
            name: "warna",
            label: "Nama Warna",
            options: {
                customBodyRender: (val) => <p>{val?.namaWarnaKomersil}</p>,
                sort: false,
            },
        },
        {
            name: "stnkName",
            label: "Nama STNK",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "buyer",
            label: "Nama Pembeli",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "frameNumber",
            label: "Nomor Rangka",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "engineNumber",
            label: "Nomor Mesin",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "numberBPKB",
            label: "Nomor BPKB",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "pencairan",
            label: "Status Pencairan",
            options: {
                customBodyRender: (val) => {
                    return (
                        <div className="margin-bottom-none width width-100px">
                            <input
                                id="input_text_kodeKSU"
                                style={{ backgroundColor: getColor(val) }}
                                type="text"
                                className="txt txt-sekunder-color"
                                disabled={true}
                                value={val ?? ""}
                            />
                        </div>
                    )
                },
                sort: false,
            },
        },
    ]
}

const getColor = (val) => {
    switch (val) {
        case "LUNAS":
            return "lime";
        case "BELUM LUNAS":
            return "red";
        default:
            return "#E6E6E6";
    }
}

export function downloadPdf(blob, fileName) {
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export async function printPDF(data) {
  try {
    const blobUrl = URL.createObjectURL(data);

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
          <html>
            <head>
              <title>Print PDF</title>
              <link rel="icon" type="image/x-icon" href="/iconnagamas.ico" />
              <style>
                html, body { margin: 0; padding: 0; height: 100%; overflow: hidden; }
                iframe { width: 100%; height: 100%; border: none; }
              </style>
            </head>
            <body>
              <iframe id="pdfFrame" src="${blobUrl}"></iframe>
              <script>
                const iframe = document.getElementById('pdfFrame');
                iframe.onload = function () {
                  setTimeout(() => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  }, 500);
                };
              </script>
            </body>
          </html>
        `);

    printWindow.document.close();
  } catch (error) {
    console.error("Failed to load or print PDF Blob:", error);
  }
};